import { ComponentProps } from 'react';

import ItemShelf from '@/components/ItemShelf/ItemShelf';
import { ItemShelfCarousel } from '@/components/ItemShelfCarousel/ItemShelfCarousel';
import { useAppSelector } from '@/redux/hooks';
import {
    getHasSavedSearchItems,
    getSavedSearchItemIds,
    LOADING_SAVED_SEARCH_ITEM_IDS,
    savedSearchSearchesSelector,
} from '@/redux/modules/savedSearch';
import { getHasSavedSearches } from '@/redux/modules/saveSearch';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getForYouUrl } from '@/utils/urls';

import FollowedSearchesLinks from './FollowedSearchesLinks';

type Props = {
    className?: string;
    shouldUseHomePageRedesign?: boolean;
};

export const FollowedSearchCarousel = ({ className, shouldUseHomePageRedesign = false }: Props) => {
    const formatMessage = useAppFormatMessage();
    const savedSearches = useAppSelector(savedSearchSearchesSelector);
    const itemIds = useAppSelector(getSavedSearchItemIds);
    const hasSavedSearches = useAppSelector(getHasSavedSearches);
    const hasSavedSearchResults = useAppSelector(getHasSavedSearchItems);

    if (!hasSavedSearchResults || !hasSavedSearches) {
        return null;
    }

    const shelfProps: ComponentProps<typeof ItemShelf> = {
        className,
        cta: itemIds.length > 6,
        identifier: LOADING_SAVED_SEARCH_ITEM_IDS,
        itemIds,
        links: <FollowedSearchesLinks savedSearches={savedSearches} />,
        seeAllUrl: getForYouUrl(),
        showPagination: false,
        title: String(formatMessage(['followedSearchCarousel', 'header'])),
    };

    if (shouldUseHomePageRedesign) {
        const { cta, ...itemShelfCarouselProps } = shelfProps;
        return (
            <ItemShelfCarousel
                {...itemShelfCarouselProps}
                shouldShowViewAll={cta}
            />
        );
    }

    return <ItemShelf {...shelfProps} />;
};
